import { render, staticRenderFns } from "./FlowCardItemDetails.vue?vue&type=template&id=5f52d1fa&scoped=true&"
import script from "./FlowCardItemDetails.vue?vue&type=script&lang=js&"
export * from "./FlowCardItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlowCardItemDetails.vue?vue&type=style&index=0&id=5f52d1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52d1fa",
  null
  
)

export default component.exports